module.exports = __webpack_public_path__ + "img/1476861769.81541326.jpg";